import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "selectedCount", "normalHeader", "selectionHeader"]

  connect() {
    this.lastChecked = null
    this.updateHeaderVisibility()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach((cb) => {
      cb.checked = checked
    })
    this.updateHeaderVisibility()
  }

  toggle(event) {
    // Shift-click for range selection
    if (event.shiftKey && this.lastChecked) {
      const checkboxes = this.checkboxTargets
      const start = checkboxes.indexOf(this.lastChecked)
      const end = checkboxes.indexOf(event.target)
      const range = [start, end].sort((a, b) => a - b)

      for (let i = range[0]; i <= range[1]; i++) {
        checkboxes[i].checked = event.target.checked
      }
    }

    this.lastChecked = event.target
    this.updateSelectAllState()
    this.updateHeaderVisibility()
  }

  updateSelectAllState() {
    if (!this.hasSelectAllTarget) return

    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter((cb) => cb.checked).length

    this.selectAllTarget.checked = checked === total && total > 0
    this.selectAllTarget.indeterminate = checked > 0 && checked < total
  }

  updateHeaderVisibility() {
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length
    const hasSelection = checkedCount > 0

    // Toggle header visibility
    if (this.hasNormalHeaderTarget && this.hasSelectionHeaderTarget) {
      this.normalHeaderTarget.classList.toggle("hidden", hasSelection)
      this.normalHeaderTarget.classList.toggle("flex", !hasSelection)
      this.selectionHeaderTarget.classList.toggle("hidden", !hasSelection)
    }

    // Update count
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = checkedCount
    }
  }

  getSelectedIds() {
    return this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
  }

  // Called when bulk action is submitted
  submitBulkAction(event) {
    const selectedIds = this.getSelectedIds()
    if (selectedIds.length === 0) {
      event.preventDefault()
      return false
    }
  }

  // Reset selection after action
  resetSelection() {
    this.checkboxTargets.forEach((cb) => {
      cb.checked = false
    })
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }
    this.updateHeaderVisibility()
  }
}
